const helperQuestion = {
	init: (): void => {
		helperQuestion.buttons();
	},

	buttons: (): void => {
		const helpfullYes = document.querySelector(".article__helpfullYes");
		const helpfullNo = document.querySelector(".article__helpfullNo");

		if (helpfullYes != null && helpfullNo != null) {
			const helpfullContainer = document.querySelector(".article__helpfull");
			const answerDict = helpfullContainer.getAttribute("data-answerDict");

			helpfullYes.addEventListener("click", () => {
				//@ts-ignore
				ga("send", "event", "Helped - " + helpfullYes, "Helped", null, null);
				helpfullContainer.innerHTML =
					'<div class="article__helpfullAnswer">' + answerDict + "</div>";
			});

			helpfullNo.addEventListener("click", () => {
				//@ts-ignore
				ga(
					"send",
					"event",
					"Did not help - " + helpfullNo.value,
					"Did not help",
					null,
					null,
				);
				helpfullContainer.innerHTML =
					'<div class="article__helpfullAnswer">' + answerDict + "</div>";
			});
		}
	},
};

export default helperQuestion;
